import type { ComponentType } from 'react';
import { Center, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { Link } from 'react-router-dom';

import type { FigmaIconProps } from '@/assets/icons';
import { IconFigmaArrowRight } from '@/assets/icons';

interface SecondaryEntryCardProps {
  icon: ComponentType<FigmaIconProps>;
  title: string;
  subtitle: string;
  to: string;
  showTrailingArrow?: boolean;
}

export const SecondaryEntryCard = ({
  icon: Icon,
  title,
  subtitle,
  to,
  showTrailingArrow = true
}: SecondaryEntryCardProps) => (
  <UnstyledButton
    component={Link}
    to={to}
    w="100%"
    p={14}
    style={{
      borderRadius: 10,
      border: '1px solid var(--color-border-default)',
      backgroundColor: 'var(--color-bg-surface)'
    }}
  >
    <Group gap={12} wrap="nowrap" align="center">
      <Center w={36} h={36} style={{ flexShrink: 0 }}>
        <Icon size={18} color="var(--color-text-secondary)" />
      </Center>
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
        <Text fz={14} fw={600} style={{ color: 'var(--color-text-primary)' }}>
          {title}
        </Text>
        <Text fz={12} style={{ color: 'var(--color-text-secondary)' }}>
          {subtitle}
        </Text>
      </Stack>
      {showTrailingArrow && <IconFigmaArrowRight size={18} color="var(--color-text-secondary)" />}
    </Group>
  </UnstyledButton>
);
